import { toast } from "react-toastify";

import { Button } from "../../../../../../common/Atoms/Button";
import { useGeneralSettingsForm } from "../../../../../hooks/useGeneralSettingsForm";
import { useGetSelectedOrganisation } from "../../../../../hooks/useGetSelectedOrganisation";
import { useCreateSenderProfileMutation } from "../../../../../services/api/settingsApi/settings";
import { TwoColFormRow } from "../../../../Molecules/Form/TwoColFormRow";

import { SenderProfile } from "./SenderProfile";

export function SenderProfilesRoot() {
  const TEMP_LIMIT = 10; // TODO make this dynamic based on plans etc
  const currentOrg = useGetSelectedOrganisation();
  const { formData } = useGeneralSettingsForm();
  const [createSenderProfile, { isLoading: senderProfileLoading }] = useCreateSenderProfileMutation();

  const senderProfiles = formData?.senderProfiles || [];

  function onCreateSenderProfile() {
    if (!currentOrg) {
      return;
    }

    if (senderProfiles.length >= TEMP_LIMIT) {
      toast.error(`You have reached the maximum number of sender profiles allowed (${TEMP_LIMIT}). Please delete an existing profile to create a new one.`);

      return;
    }

    createSenderProfile(currentOrg?.id);
  }

  return (
    <TwoColFormRow
      heading={ `Email Sender Profiles` }
      description={ `The default profile will be used unless otherwise specified in the relevant policies.` }
    >
      <div className={ `mt-2 space-y-4` }>
        {
          senderProfiles.map((p, idx) => {
            return (
              <SenderProfile
                key={ `senderProfile-${p.id}` }
                profile={ p }
                index={ idx }
              />
            );
          })
        }
      </div>

      <div className={ `flex justify-center mt-4` }>
        <Button
          color={ `paidniceGreenOutline` }
          size={ `s` }
          onClick={ onCreateSenderProfile }
          loading={ senderProfileLoading }
          disabled={ senderProfiles.length >= TEMP_LIMIT }
        >
          { `Create Sender Profile` }
        </Button>
      </div>
    </TwoColFormRow>
  );
}
